import { formatExportedAt } from '@/pocs/chat/export/transcript'
import type { ChatTranscript } from '@/pocs/chat/export/types'

function toBlockquote(text: string) {
  return text
    .split('\n')
    .map((line) => `> ${line}`)
    .join('\n')
}

export function toMarkdown(transcript: ChatTranscript): string {
  const { title, contextFolders, exchanges, labels } = transcript
  const header = [
    `# ${title}`,
    `**${labels.context}:** ${contextFolders.join(', ')}`,
    `_${labels.generatedBy} · ${formatExportedAt(transcript)}_`,
  ]
  const body = exchanges.map(({ question, answer, isComplete }) =>
    [
      `## ${labels.question}`,
      toBlockquote(question),
      `## ${labels.answer}`,
      answer,
      ...(isComplete ? [] : [`_${labels.incompleteAnswer}_`]),
    ].join('\n\n'),
  )
  return `${[header.join('\n\n'), ...body].join('\n\n---\n\n')}\n`
}
